import "../../WidgetModal.css";
import "../../lodging/add-lodging/add-lodging.css";
import "react-day-picker/lib/style.css";

import React, { useState, useEffect, SetStateAction, useContext } from "react";
import { Col, Row, Modal, Spinner } from "react-bootstrap";
import reactMoment from "react-day-picker/moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import CustomItem from "../../../../../../../Data/CustomItem";
import UseGetCustomVendors, { GetCustomVendorsRequest, GetCustomVendorsResponse } from "./data-service-hooks/UseGetCustomVendors";
import VendorCard from "../../VendorCard";
import CustomDetails from "../custom-details/CustomDetails";
import { Modifier } from "react-day-picker";
import { DatesAndGuests } from "../../../../widget-form/WidgetForm";
import CustomItineraryUnit from "../../../../../../../Data/Reservation/Custom/CustomItineraryUnit";
import { WidgetContext } from "../../../../../../../context/WidgetContext";
import moment from "moment";
import ViewPort from "../../../../../../../_helpers/Enums/ViewPortEnum";
import AddModalSortBy from "../../AddModalSortBy";

interface props {
  show: boolean,
  onHide: () => void;
  brandId: number,
  datesAndGuests: DatesAndGuests;
  onSelectedCustom?: (item: CustomItem, index?: number) => void;
  unitToEditState?: [CustomItineraryUnit | undefined, React.Dispatch<SetStateAction<CustomItineraryUnit | undefined>>];
  vendorGuid: string | undefined;
  vendorGuidType: string | undefined;
}

const AddCustomModal: React.FC<props> = (props) => {
  const { startWidget, style, viewPortBreakPoint } = useContext(WidgetContext);
  const [simpleView, setSimpleView] = useState(viewPortBreakPoint >= ViewPort.md ? false : true);

  const { show, onHide, brandId, onSelectedCustom } = props;
  const [datesAndGuests, setDatesAndGuests] = useState<DatesAndGuests>(props.datesAndGuests);
  const unitToEdit = props.unitToEditState ? props.unitToEditState[0] : undefined;
  const setUnitToEdit = props.unitToEditState ? props.unitToEditState[1] : undefined;
  const [customVendors, setCustomVendors] = useState<any>();
  const [selectedVendor, setSelectedVendor] = useState<CustomItem | undefined>(unitToEdit ? undefined : undefined);
  const { formatDate, parseDate } = reactMoment;
  const modifiers = { start: datesAndGuests.fromDate, end: datesAndGuests.toDate };

  const [priceFilter, setPriceFilter] = useState<number>(0);
  const [cityFilter, setCityFilter] = useState<string>("");

  const [getCustomVendorsRequest, setGetCustomVendorsRequest] = useState<GetCustomVendorsRequest>();
  const responseGetCustomVendors = UseGetCustomVendors(getCustomVendorsRequest);

  const [cityOptions, setCityOptions] = useState<string[]>([]);

  const onSelectedVendor = (vendor: CustomItem) => {
    setSelectedVendor(vendor);
  }

  const onSelectedVendorUnit = (item: CustomItem, index?: number) => {
    if (onSelectedCustom) {
      onSelectedCustom(item, index);
    }

    setSelectedVendor(undefined);
  }

  const sortByPrice = (e: any) => {
    setPriceFilter(+e.target.value);
  }

  const sortByCity = (e: any) => {
    setCityFilter(e.target.value);
  }

  useEffect(() => {
    let fromDateString = moment(datesAndGuests.fromDate).format("YYYY-MM-DD");
    let toDateString = moment(datesAndGuests.toDate).format("YYYY-MM-DD");
    setGetCustomVendorsRequest({
      brandId,
      startDate: fromDateString,
      endDate: toDateString,
      vendorGuid: props.vendorGuidType === "Custom" ? props.vendorGuid : undefined 
    });
  }, [setCustomVendors]);

  useEffect(() => {
    if (responseGetCustomVendors.data) {
      // let responseData: GetCustomVendorsResponse = responseGetCustomVendors.data;
      const responseData = responseGetCustomVendors.data;
      // console.log("responseData", responseData);
      if (props.vendorGuid !== undefined && responseData.length > 0 && responseData[0].vendorGuid === props.vendorGuid) {
        onSelectedVendor({ ...responseData[0] })
        return;
      }

      const fromPrice = Number.MAX_VALUE;
      const vendors = responseData.map((v: any) => {
        let price = fromPrice;
        if (v.rates !== null && v.rates !== undefined && v.rates.length > 0 && v.rates.some((dr: any) => dr.rates.length > 0)) {
          //search for lowest price

          for (let dRate = 0; dRate < v.rates.length; dRate++) {
            const dateRate = v.rates[dRate];
            for (let uRate = 0; uRate < dateRate.rates.length; uRate++) {
              const unitRate = dateRate.rates[uRate];
              for (let pRate = 0; pRate < unitRate.rates.length; pRate++) {
                const productRate = unitRate.rates[pRate];
                if (productRate.price < price) {
                  price = productRate.price;
                }
              }
            }
          }
        }
        return { ...v, fromPrice: price }
      });
      setCustomVendors(vendors);

      const cities: string[] = [];
      for (let index = 0; index < vendors.length; index++) {
        const vendor = vendors[index];
        if (cities.includes(vendor.city)) continue;

        cities.push(vendor.city);
      }
      setCityOptions(cities);

      if (unitToEdit !== undefined) {
        const vendor: CustomItem = responseData.find((v: any) => v.vendorId === unitToEdit.vendorId);
        vendor.startDate = unitToEdit.startDate;
        vendor.endDate = unitToEdit.endDate;
        vendor.startTime = unitToEdit.startTime;
        vendor.endTime = unitToEdit.endTime;
        vendor.numberOfUnits = unitToEdit.numberOfUnits;
        vendor.numberOfGuests = unitToEdit.numberOfGuests;
        vendor.itineraryIndex = unitToEdit.itineraryIndex;
        setSelectedVendor(vendor);
      }
    }
  }, [responseGetCustomVendors.data]);

  return (

    <React.Fragment>
      <Modal
        scrollable={true}
        size="lg"
        show={show && !!!selectedVendor}
        onHide={onHide}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header translate="" closeButton closeLabel="close window">
        <AddModalSortBy 
            modalTitle='Add Extras'
            datesAndGuests={datesAndGuests}
            simpleView={simpleView}
            setSimpleView={setSimpleView}
            filterPricing={sortByPrice}
            cityOptions={cityOptions}
            filterCities={sortByCity}
          />
        </Modal.Header>
        <Modal.Body>
          {/* Desktop */}
          <Row className="d-flex justify-content-center">
            <Col xs={12}>
              {responseGetCustomVendors.isLoading && (
                <span><Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /> Loading...</span>
              )}
              {customVendors && (customVendors.length == 0 || customVendors.filter((v: any) => v.showOnCustomerPortal).length === 0) && (
                <p className="font-italic text-dark">No results found</p>
              )}
              {customVendors && customVendors.filter((v: any) => v.showOnCustomerPortal).length > 0 &&
                customVendors.filter((v: any) => v.showOnCustomerPortal)
                  .filter((v: any) => cityFilter === "" || v.city === cityFilter)
                  .sort((a: any, b: any) => {
                    if (a.sortOrder < b.sortOrder) return -1;
                    if (a.sortOrder > b.sortOrder) return 1;
                    return 0;
                  })
                  .sort((a: any, b: any) => {
                    if (priceFilter === 0) return 0;
                    if (a.fromPrice < b.fromPrice) return priceFilter === 10 ? -1 : 1;
                    if (a.fromPrice > b.fromPrice) return priceFilter === 10 ? 1 : -1;
                    return 0;
                  })
                  .map((vendor: CustomItem, index: number) => (
                    <VendorCard
                      key={index}
                      vendor={vendor}
                      datesAndGuests={datesAndGuests}
                      onSelectedVendor={onSelectedVendor}
                      sortedBy={priceFilter}
                      simpleView={simpleView}
                    />
                  ))}
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        scrollable={true}
        show={!!selectedVendor} //state.showDetailModal
        size="lg"
        onHide={() => {
          setSelectedVendor(undefined);
          if (!!setUnitToEdit) {
            setUnitToEdit(undefined);
          }
        }}
        backdropClassName="white-overlay"
        dialogClassName="box-shadow mobile-full-width"
      >
        <Modal.Header translate="" closeButton closeLabel="close window">
          <Modal.Title
            className="d-flex flex-column justify-content-between"
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold", color: style.fontColor }}
          >
            <h4 className="m-0 p-0" style={{ color: style.fontColor, fontSize: "1.2rem" }}>{selectedVendor ? selectedVendor.vendorName : undefined}</h4>
            {viewPortBreakPoint >= ViewPort.md && (
              <h6 className="m-0 p-0 pt-2">{selectedVendor ? selectedVendor.streetAddress : undefined} {selectedVendor ? selectedVendor.city : undefined} {selectedVendor ? selectedVendor.state : undefined} {selectedVendor ? selectedVendor.zipCode : undefined}</h6>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVendor && (
            <CustomDetails
              vendor={selectedVendor}
              datesAndGuests={datesAndGuests}
              onSelectedVendorUnit={onSelectedVendorUnit}
            />
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}


export default AddCustomModal;
